export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_31-12794813ec9277f6624336bfa097a824.jpg";